import * as Sentry from "@sentry/browser";

import { TEMP_IMG } from "../config.js";
import i18next from "../i18n";
import View from "./View";

const SINGLE_SELECTION_MAXIMUM = 1;

class ProductView extends View {
  _btnCart = document.querySelector(".footer-container .button-container");
  _btnCloseItemContainer = document.querySelector(
    ".overlay-container.item .button-close-container",
  );
  _btnLess = document.querySelector(".decrease-quantity-by-one");
  _btnMore = document.querySelector(".increase-quantity-by-one");
  _container = document.querySelector(".content-container-add");
  _count = document.querySelector(".item-count");
  _data;
  _description = document.querySelector(".ingredient-list-js.add");
  _FREE_MODIFIER_PRICE = 0;
  _imgBlock = document.querySelectorAll(".item-image-block .image-item");
  _instruction = document.querySelector(".special-instruction-inputfield");
  _itemContainerName = document.querySelector(".div-header-modal");
  _itemCount = document.querySelector(".item-count");
  _itemCountEl = Number(document.querySelector(".item-count").textContent);
  _itemPrice = undefined;
  _itemPriceTotal = undefined;
  _modalBackgroundItem = document.querySelector(".modal-background.item");
  _modifier = document.querySelector(".modifier-container");

  _totalIngredientPrice = 0;

  // Clear the content of the elements
  _clear() {
    this._modifier.innerHTML = "";
    this._itemContainerName.innerHTML = "";
    this._description.innerHTML = "";
    this._btnCart.innerHTML = "";
    this._instruction.value = "";
    this._btnCloseItemContainer.innerHTML = "";
  }

  _generateAddButton() {
    return `<button class="add-to-cart w-button" type="submit">
              <span>${i18next.t("actions.addToCart")} -&nbsp;</span>
              <span class="item-price-modal">${this.formatCurrency(
                this._data.price,
              )}</span>
            </button>`;
  }

  _generateCloseAddItem() {
    return `
      <button
        type="button"
        class="button-close add-item"
        aria-label="${i18next.t("actions.close")}"
      >
        <!-- Controled by DOM -->
        <span class="svg-container">
          <!-- svg-close button -->
          <svg
            class="svg-close"
            fill="currentColor"
            version="1.1"
            viewBox="0 0 460.775 460.775"
            xml:space="preserve"
          >
            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55 c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55 c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505 c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55 l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719 c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z" />
          </svg>
        </span>
      </button>
    `;
  }

  _generateCloseUpdateItem() {
    return `
      <button
        type="button"
        class="button-close update-item"
        aria-label="${i18next.t("actions.close")}"
      >
        <!-- Controled by DOM -->
        <span class="svg-container">
          <!-- svg-close button -->
          <svg
            class="svg-close"
            fill="currentColor"
            version="1.1"
            viewBox="0 0 460.775 460.775"
            xml:space="preserve"
          >
            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55 c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55 c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505 c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55 l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719 c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z" />
          </svg>
        </span>
      </button>
    `;
  }

  _generateMarkupDescription() {
    return `<p>${this._data.description}</p>`;
  }

  _generateMarkupModifier() {
    return `
            ${this._data.modifierGroups
              .map((option) => {
                if (
                  option.modifierType === "SINGLE_VALUE" &&
                  option.isRequired
                ) {
                  return `
                    <div class="w-layout-grid option-container-js" data-id=${
                      option.idModifierGroup
                    }>
                        <div  class="option-header-container">
                            <div class="option-field-js">
                              <span> ${option.name}</span>
                              <span class="required-input">${i18next.t("validation.required")}</span>
                            </div>
                        </div>
                        <div class="modifier-select-label">
                          ${this._generateModifierSelectionLabel(option)}
                        </div>
                    ${option.modifierItems
                      .map(
                        (modifier) => `
                        <div  class="option-input-js radio">
                            <div class="toggle-container">
                                <label for="toggle-${
                                  modifier.idModifierItem
                                }" class="modifier-label-container">
                                    <input type="radio" id="toggle-${
                                      modifier.idModifierItem
                                    }" name="${
                                      option.name
                                    }" class="toggle-input-radio">
                                    <span class="radio-container">  </span> 
                                    <span class="modifier-item-name">${
                                      modifier.name
                                    }</span>
                                    ${
                                      modifier.price > this._FREE_MODIFIER_PRICE
                                        ? `<span class="modifier-item-price">${this.formatCurrency(
                                            modifier.price,
                                          )}</span>`
                                        : `<span class="modifier-item-price"></span>`
                                    }
                                </label>
                            </div>
                        </div>  
                    `,
                      )
                      .join("")}
                    </div>  
                    `;
                }
                if (
                  option.modifierType === "SINGLE_VALUE" &&
                  !option.isRequired
                ) {
                  return `
                      <div class="w-layout-grid option-container-js" data-id=${
                        option.idModifierGroup
                      }>
                          <div  class="option-header-container">
                              <div class="option-field-js">${option.name}
                              </div>
                          </div>
                          <div class="modifier-select-label">
                            ${this._generateModifierSelectionLabel(option)}
                          </div>
                      ${option.modifierItems
                        .map(
                          (modifier) => `
                          <div  class="option-input-js radio">
                              <div class="toggle-container">
                                  <label for="toggle-${
                                    modifier.idModifierItem
                                  }" class="modifier-label-container">
                                      <input type="radio" id="toggle-${
                                        modifier.idModifierItem
                                      }" name="${
                                        option.name
                                      }" class="toggle-input-radio">
                                      <span class="radio-container">  </span> 
                                      <span class="modifier-item-name">${
                                        modifier.name
                                      }</span>
                                      ${
                                        modifier.price >
                                        this._FREE_MODIFIER_PRICE
                                          ? `<span class="modifier-item-price">${this.formatCurrency(
                                              modifier.price,
                                            )}</span>`
                                          : `<span class="modifier-item-price"></span>`
                                      }
                                  </label>
                              </div>
                          </div>  
                      `,
                        )
                        .join("")}
                      </div>  
                      `;
                }
                if (
                  option.modifierType === "MULTIPLE_VALUES" &&
                  option.isRequired
                ) {
                  return `
                          <div class="w-layout-grid option-container-js" data-id=${
                            option.idModifierGroup
                          }>
                              <div  class="option-header-container">
                                  <div class="option-field-js">                            
                                  <span> ${option.name}</span>
                                  <span class="required-input">${i18next.t("validation.required")}</span>
                                  </div>
                              </div>
                              <div class="modifier-select-label">
                                ${this._generateModifierSelectionLabel(option)}
                              </div>
                          ${option.modifierItems
                            .map(
                              (modifier) => `
                              <div  class="option-input-js checkbox">
                                  <div class="toggle-container">
                                      <label for="toggle-${
                                        modifier.idModifierItem
                                      }" class="modifier-label-container">
                                          <input type="checkbox" id="toggle-${
                                            modifier.idModifierItem
                                          }" name="${
                                            option.name
                                          }"  class="toggle-input-checkbox">
                                          <span class="checkbox-container"> </span>
                                          <span class="modifier-item-name">${
                                            modifier.name
                                          }</span>
                                          ${
                                            modifier.price >
                                            this._FREE_MODIFIER_PRICE
                                              ? `<span class="modifier-item-price">${this.formatCurrency(
                                                  modifier.price,
                                                )}</span>`
                                              : `<span class="modifier-item-price"></span>`
                                          } 
                                      </label>
                                  </div>
                              </div>
                          `,
                            )
                            .join("")}
                          </div>  
                          `;
                }
                if (
                  option.modifierType === "MULTIPLE_VALUES" &&
                  !option.isRequired
                ) {
                  return `
                        <div class="w-layout-grid option-container-js" data-id=${
                          option.idModifierGroup
                        }>
                            <div  class="option-header-container">
                                <div class="option-field-js">${option.name}
                                </div>
                            </div>
                            <div class="modifier-select-label">
                              ${this._generateModifierSelectionLabel(option)}
                            </div>
                        ${option.modifierItems
                          .map(
                            (modifier) => `
                            <div  class="option-input-js checkbox">
                                <div class="toggle-container">
                                    <label for="toggle-${
                                      modifier.idModifierItem
                                    }" class="modifier-label-container">
                                        <input type="checkbox" id="toggle-${
                                          modifier.idModifierItem
                                        }" name="${
                                          option.name
                                        }" class="toggle-input-checkbox">
                                        <span class="checkbox-container"> </span>
                                        <span class="modifier-item-name">${
                                          modifier.name
                                        }</span>
                                        ${
                                          modifier.price >
                                          this._FREE_MODIFIER_PRICE
                                            ? `<span class="modifier-item-price">${this.formatCurrency(
                                                modifier.price,
                                              )}</span>`
                                            : `<span class="modifier-item-price"></span>`
                                        } 
                                    </label>
                                </div>
                            </div>
                        `,
                          )
                          .join("")}
                        </div>  
                        `;
                }
                return "";
              })
              .join("")}
        `;
  }

  _generateMarkupName() {
    return `<h1 class="item-name-add">${this._data.name}</h1>`;
  }

  // Single-value groups always select one item, even when an optional group's minimum is zero.
  _generateModifierSelectionLabel(option) {
    const maximum =
      option.modifierType === "SINGLE_VALUE"
        ? SINGLE_SELECTION_MAXIMUM
        : option.maxChoiceItem;
    const maximumMarkup = `<span class="modifier-select-quantity">${maximum}</span>`;

    if (
      option.modifierType === "MULTIPLE_VALUES" &&
      option.minChoiceItem !== option.maxChoiceItem
    ) {
      return `${i18next.t("actions.select")} ${i18next.t("limits.upTo")} ${maximumMarkup}`;
    }

    return `${i18next.t("actions.select")} ${maximumMarkup}`;
  }

  _generateUpdateButton() {
    return `<button class="update-cart w-button" type="submit">
              <span>${i18next.t("actions.updateItem")} -&nbsp;</span>
              <span class="item-price-modal">${this.formatCurrency(
                this._data.priceTotal,
              )}</span>
            </button>`;
  }

  closeBckgrndItem() {
    const addItemButton =
      this._modalBackgroundItem.nextElementSibling.querySelector(
        ".button-close.add-item",
      );
    const updateItemButton =
      this._modalBackgroundItem.nextElementSibling.querySelector(
        ".button-close.update-item",
      );

    if (addItemButton) {
      // Hide modal item after modal background click
      this._modalBackgroundItem.onclick = () => this.closeModalItem();
    } else if (updateItemButton) {
      // Hide modal item and show modal checkout after close icon click
      this._modalBackgroundItem.onclick = () => {
        // Hide item modal
        this._overlayItem.style.display = "none";

        // Show checkout modal
        this._overlayCheckout.style.display = "block";

        // Hide scroll bar
        document.body.style.overflow = "hidden";
      };
    }
  }

  // Hide modal item after close icon click
  closeModalAddItem() {
    const closeBtnAddItem = document.querySelector(".button-close.add-item");

    closeBtnAddItem.onclick = () => this.closeModalItem();
  }

  // Close item modal
  closeModalItem() {
    // Hide modal
    this._overlayItem.style.display = "none";

    // Show scroll bar
    document.body.style.overflow = "visible";
  }

  // Hide modal item and show modal checkout after close icon click
  closeModalUpdateItem() {
    const closeBtnUpdateItem = document.querySelector(
      ".button-close.update-item",
    );

    closeBtnUpdateItem.onclick = () => {
      // Hide item modal
      this._overlayItem.style.display = "none";

      // Show checkout modal
      this._overlayCheckout.style.display = "block";

      // Hide scroll bar
      document.body.style.overflow = "hidden";
    };
  }

  // Build image loading functionality with promisify function
  createImage(imgPath) {
    const img = document.querySelector(".image-item-modal");

    return new Promise((resolve, reject) => {
      img.classList.remove("is-loaded");

      // Resolve promise when image has loaded
      img.addEventListener(
        "load",
        () => {
          img.classList.add("is-loaded");
          resolve(img);
        },
        { once: true },
      );

      // Reject promise when image has failed to load
      img.addEventListener(
        "error",
        () => {
          img.classList.remove("is-loaded");
          img.src = TEMP_IMG;
          reject(new Error(i18next.t("error.imageNotFound")));
        },
        { once: true },
      );

      img.src = imgPath;
    });
  }

  // Decrease the number of items in the cart
  decreaseElements() {
    const MIN_ITEM_COUNT = 1;

    if (this._itemCountEl > MIN_ITEM_COUNT) {
      this._itemCountEl -= 1;
      this.updateElements();
    }
  }

  // Decrease the number of items in the cart
  decreaseItems() {
    this._btnLess.onclick = this.decreaseElements.bind(this);
  }

  /* Show food modal and load image on image click */

  // Render required modifiers
  findRequiredModifier() {
    // Find all modifiers
    const modifierArray = Array.from(
      document.querySelectorAll(".option-container-js"),
    );

    // Create empty array
    const arrayEmpty = [];

    // Add required modifier to the empty array
    modifierArray.forEach((el) => {
      if (el.querySelector(".required-input")) {
        arrayEmpty.push(el);
      }
    });

    return arrayEmpty;
  }

  // Increase the number of items in the cart
  increaseElements() {
    const MAX_ITEM_COUNT = 99;

    if (this._itemCountEl < MAX_ITEM_COUNT) {
      this._itemCountEl += 1;
      this.updateElements();
    }
  }

  increaseItems() {
    this._btnMore.onclick = this.increaseElements.bind(this);
  }

  // Limit the number of options a user may choose in a modifier
  limitModifierSelection() {
    const NO_MODIFIER_OPTIONS = 0;

    const modifierContainers = document.querySelectorAll(
      ".option-container-js",
    );
    const { modifierGroups } = this._data;

    modifierContainers.forEach((container) => {
      container.addEventListener("change", () => {
        const selectedOptions = Array.from(
          container.querySelectorAll('input[type="checkbox"]:checked'),
        );

        const selectedCount = selectedOptions.length;
        const containerID = Number(container.getAttribute("data-id"));

        const group = modifierGroups.find(
          (modifierGroup) => modifierGroup.idModifierGroup === containerID,
        );
        const maxOptions = group ? group.maxChoiceItem : NO_MODIFIER_OPTIONS;

        container
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            const labelContainer = input.closest(".modifier-label-container");
            if (selectedCount >= maxOptions && !input.checked) {
              input.disabled = true;
              if (labelContainer) {
                labelContainer.style.color = "gray";
                labelContainer.style.cursor = "not-allowed";
              }
            } else {
              input.disabled = false;
              if (labelContainer) {
                labelContainer.style.color = "initial";
                labelContainer.style.cursor = "pointer";
              }
            }
          });
      });
    });
  }

  // Add item to cart and close food modal on button click
  renderAddToCart(handler) {
    // Validating group of required input boxes
    const AtLeastOneCheck = handler.map((el) =>
      this.requireAtLeastOneCheck(el.querySelectorAll("input")),
    );

    // Check if required inputs are filled
    const isTrue = (currentValue) => currentValue === true;

    // If all required inputs are filled, update cart
    if (AtLeastOneCheck.every(isTrue)) {
      // Close food modal
      this.closeModalItem();

      return true;
    }

    return false;
  }

  renderAddToCartError(message = i18next.t("error.addProduct")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  // Product data is located in this._data
  renderData(data) {
    this._data = data;
    const markupModifier = this._generateMarkupModifier();
    const markupName = this._generateMarkupName();
    const markupDescription = this._generateMarkupDescription();
    const markupAddButton = this._generateAddButton();
    const markupCloseAddItem = this._generateCloseAddItem();
    this._clear();
    this._count.innerHTML = "1";
    this._itemCountEl = 1;

    // Parse the specified text as HTML and inserts the resulting nodes into the DOM tree at a specified position.
    this._modifier.insertAdjacentHTML("afterbegin", markupModifier);
    this._itemContainerName.insertAdjacentHTML("afterbegin", markupName);
    this._description.insertAdjacentHTML("afterbegin", markupDescription);
    this._btnCart.insertAdjacentHTML("afterbegin", markupAddButton);
    this._btnCloseItemContainer.insertAdjacentHTML(
      "afterbegin",
      markupCloseAddItem,
    );
  }

  renderDataUpdate(data) {
    this._data = data;
    const markupModifier = this._generateMarkupModifier();
    const markupName = this._generateMarkupName();
    const markupDescription = this._generateMarkupDescription();
    const markupUpdateButton = this._generateUpdateButton();
    const markupCloseUpdateItem = this._generateCloseUpdateItem();
    this._clear();
    this._count.innerHTML = this._data.quantity;
    this._itemCountEl = Number(this._data.quantity);
    this._instruction.value = this._data.instructions;
    // Parse the specified text as HTML and inserts the resulting nodes into the DOM tree at a specified position.
    this._modifier.insertAdjacentHTML("afterbegin", markupModifier);
    this._itemContainerName.insertAdjacentHTML("afterbegin", markupName);
    this._description.insertAdjacentHTML("afterbegin", markupDescription);
    this._btnCart.insertAdjacentHTML("afterbegin", markupUpdateButton);
    this._btnCloseItemContainer.insertAdjacentHTML(
      "afterbegin",
      markupCloseUpdateItem,
    );
    // Close modal checkout
    this.closeModalCheckout();
  }

  renderError(message = i18next.t("error.displayProduct")) {
    this._clear();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  // Render modal with product data
  renderModal(imgPath) {
    // Show modal
    this._overlayItem.style.display = "block";
    this._overlayCheckout.style.display = "none";

    // Hide scroll bar
    document.body.style.overflow = "hidden";

    // Load image with promise, handle success and error
    this.createImage(imgPath)
      .then((resolvedImgPath) =>
        // Auto-resolve promise
        Promise.resolve(resolvedImgPath),
      )
      .catch((err) => {
        // Capture the error and send to Sentry
        Sentry.captureException(err);

        console.error(err);
      });
    // Set the number of pixels the modal content is scrolled to
    this._container.scrollTop = 0;

    return true;
  }

  renderOnClick(handler) {
    const DELAY_TIMEOUT_MS = 400;

    // Open food modal on product click
    document.querySelectorAll(".item-image-block").forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("tabindex", "0");
      element.onclick = this.debounce(handler, DELAY_TIMEOUT_MS).bind(this);
      element.onkeydown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          element.click();
        }
      };
    });
  }

  renderOnClickUpdate(handler) {
    // Open food modal on product click
    document.querySelectorAll(".img-checkout-block").forEach((element) => {
      element.onclick = handler;
    });

    document.querySelectorAll(".modify-button.word-link").forEach((element) => {
      element.onclick = handler;
    });
  }

  renderRemoveCartError(message = i18next.t("error.removeProduct")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  // Add item to cart and close food modal on button click
  renderUpdateCart(handler) {
    // Validating group of required input boxes
    const AtLeastOneCheck = handler.map((el) =>
      this.requireAtLeastOneCheck(el.querySelectorAll("input")),
    );

    // Check if required inputs are filled
    const isTrue = (currentValue) => currentValue === true;

    // If all required inputs are filled, update cart
    if (AtLeastOneCheck.every(isTrue)) {
      // Close food modal
      this.closeModalItem();

      // Open checkout modal
      this.openModalCheckout();

      return true;
    }

    return false;
  }

  renderUpdateCartError(message = i18next.t("error.updateProduct")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  // Uncheck all input fields of the form after submitting the form
  uncheckInput() {
    const allInputs = document.querySelectorAll(".modifier-container input");
    allInputs.forEach((singleInput) => (singleInput.checked = false));
  }

  // Update item count and price displayed
  updateElements() {
    // Calculate total price based on number of items and ingredients
    this._itemPriceTotal =
      (this._data.price + this._totalIngredientPrice) * this._itemCountEl;
    this._itemCount.textContent = this._itemCountEl;
    this._itemPrice.textContent = `${this.formatCurrency(
      this._itemPriceTotal,
    )}`;
  }

  // Update item price in the cart
  updateItemPrice() {
    this._itemPrice = document.querySelector(".item-price-modal");
    const itemContainer = document.querySelector(".modifier-container");
    const allInputs = itemContainer.querySelectorAll("input");
    // Create modifier object
    const { modifierGroups } = this._data;

    const calculateTotalPrice = () => {
      // Filter checked modifiers
      const optionsSelected = Array.from(allInputs).filter(
        (input) => input.checked,
      );

      // Extract IDs of checked modifier using map function and regular expressions
      const modifierIDs = optionsSelected.map((input) =>
        parseInt(input.id.match(/\d+/u), 10),
      );

      // Calculate the total price of ingredients based on IDs
      const TOTAL_PRICE_NO_INGREDIENTS = 0;
      this._totalIngredientPrice = modifierGroups.reduce(
        (total, modifierGroup) => {
          // Iterate through each modifier item in the current modifier group
          modifierGroup.modifierItems.forEach((modifierItem) => {
            // Add the price of the modifier item if its ID is included in modifierIDs
            if (modifierIDs.includes(modifierItem.idModifierItem)) {
              total += modifierItem.price;
            }
          });
          return total;
        },
        TOTAL_PRICE_NO_INGREDIENTS,
      );

      // Calculate total price based on number of items and ingredients
      this._itemPriceTotal =
        (this._data.price + this._totalIngredientPrice) * this._itemCountEl;
      this._itemPrice.textContent = `${this.formatCurrency(
        this._itemPriceTotal,
      )}`;
    };

    // Initial calculation
    calculateTotalPrice();

    // Update price on modifier change
    itemContainer.addEventListener("change", calculateTotalPrice);
  }

  validateModifierSelection() {
    const NO_MODIFIER_OPTIONS = 0;
    const modifierContainers = document.querySelectorAll(
      ".option-container-js",
    );
    const { modifierGroups } = this._data;

    modifierContainers.forEach((container) => {
      const selectedOptions = Array.from(
        container.querySelectorAll('input[type="checkbox"]:checked'),
      );

      const selectedCount = selectedOptions.length;
      const containerID = Number(container.getAttribute("data-id"));

      const group = modifierGroups.find(
        (modifierGroup) => modifierGroup.idModifierGroup === containerID,
      );
      const maxOptions = group ? group.maxChoiceItem : NO_MODIFIER_OPTIONS;

      container.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        const labelContainer = input.closest(".modifier-label-container");
        if (selectedCount >= maxOptions && !input.checked) {
          input.disabled = true;
          if (labelContainer) {
            labelContainer.style.color = "gray";
            labelContainer.style.cursor = "not-allowed";
          }
        } else {
          input.disabled = false;
          if (labelContainer) {
            labelContainer.style.color = "initial";
            labelContainer.style.cursor = "pointer";
          }
        }
      });
    });
  }
}

export default new ProductView();
